import React from 'react'
import styled from 'styled-components'

import Logo from '../../images/svg/motat_header.svg'
import Link from '../atoms/link'
import theme from '../atoms/theme'
import { LogoContainer, MotatLogo } from './navigation'

const { breakpoints, colours, font, padding } = theme

export const navigationVars = {
  desktopHeight: '11.2rem',
  mobileHeight: '6.2rem',
}

const NavigationContainer = styled.div`
  background-color: ${colours.dark};
`

const LogoTitle = styled.div`
  color: ${colours.light};
  font-size: 1rem;
  line-height: 1.2rem;
  margin-bottom: 0.6rem;
  font-weight: ${font.fontWeightNormal};

  @media only screen and ${breakpoints.fromNormalScreen} {
    font-size: ${font.fontSizeDesktop};
    line-height: ${font.fontSizeDesktop};
    margin-bottom: 1.8rem;
  }
`

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  height: ${navigationVars.mobileHeight};

  @media only screen and ${breakpoints.fromNormalScreen} {
    height: ${navigationVars.desktopHeight};
    padding: 0 ${padding.tabletDefault};
  }

  @media only screen and ${breakpoints.fromLargeScreen} {
    padding: 0 ${padding.screenDefault};
  }
`

type InteractiveNavigationTypes = {
  isSimple: boolean
}

const InteractiveNavigation = (
  props: InteractiveNavigationTypes,
): JSX.Element => {
  const { isSimple } = props

  return (
    <div data-scroll-section>
      {!isSimple && (
        <nav>
          <NavigationContainer>
            <FlexContainer>
              <Link to={'/'}>
                <LogoContainer>
                  <LogoTitle>Museum of Transport and Technology</LogoTitle>
                  <MotatLogo>
                    <Logo />
                  </MotatLogo>
                </LogoContainer>
              </Link>
            </FlexContainer>
          </NavigationContainer>
        </nav>
      )}
    </div>
  )
}

export default InteractiveNavigation
